<template>
  <ForgotPasswordForm :loading="loading" @submit="onSubmit" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useAuthenticator } from '@infuse/auth/services';
import { ForgotPasswordForm } from '@infuse/auth/ui';
import { useNotify } from '@infuse/ui/services';
import { UiNotificationType } from '@infuse/ui/domain';

const { t } = useI18n();
const router = useRouter();
const notify = useNotify();

const loading = ref(false);

async function onSubmit(form: { username: string }) {
  loading.value = true;

  try {
    await useAuthenticator().forgotPassword(form.username);

    notify({
      type: UiNotificationType.SUCCESS,
      group: 'notify-top',
      title: t('auth.notification.reset_requested_title'),
      message: t('auth.notification.reset_requested_message')
    });

    router.push('/auth/reset-password');
  } catch (e) {
    notify({
      type: UiNotificationType.ERROR,
      group: 'notify-top',
      title: t('auth.notification.reset_request_failed_title'),
      message: t('auth.notification.reset_request_failed_message')
    });
  } finally {
    loading.value = false;
  }
}
</script>
